export default __webpack_public_path__ + "static/media/company_lg.c53e1e12.jpg";